import React, { PureComponent } from "react";
import QueryString from "query-string";

import { Redirect } from "../../../common/components";

class Error extends PureComponent {
  render() {
    const { state } = QueryString.parse(this.props.location.search);
    const { destination } = JSON.parse(atob(state));

    return <Redirect url={destination} />;
  }
}

export default Error;
